import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from '../Services/logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const loggingService = this.injector.get(LoggingService);

    // Extraer el error original si es un error de Angular
    const unwrappedError = error.rejection ? error.rejection : error;
    console.error('Error global capturado:', unwrappedError); // Mantener el log en consola
    // Enviar el error al backend
    // loggingService.logError(unwrappedError).subscribe({
    //   error: (err) => console.error('Fallo al loguear el error en el backend:', err)
    // });

    // Opcional: Aquí podrías mostrar un mensaje genérico al usuario si lo deseas
    // const messageService = this.injector.get(MessageService);
    // messageService.add({ severity: 'error', summary: 'Error Inesperado', detail: 'Ha ocurrido un error inesperado. El equipo de soporte ha sido notificado.' });
  }
}
